module.exports = {"360825100":"恩江镇","360825101":"坑田镇","360825102":"沿陂镇","360825103":"古县镇","360825104":"瑶田镇","360825105":"藤田镇","360825106":"石马镇","360825107":"沙溪镇","360825200":"佐龙乡","360825201":"八江乡","360825202":"潭城乡","360825203":"鹿冈乡","360825204":"七都乡","360825205":"陶塘乡","360825206":"中村乡","360825207":"上溪乡","360825208":"潭头乡","360825209":"三坊乡","360825210":"上固乡","360825211":"君埠乡","360825212":"龙冈畲族乡","360825403":"永丰县工业园区","360825501":"罗铺垦殖场","360825502":"官山林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360825.json
// module id = 1210
// module chunks = 0